import { useTheme } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

import { FooterScorenco } from '../FooterScorenco';
import { WidgetPopupAd } from '../WidgetPopupAd';
import { WidgetsGlobalStyles } from './WidgetsGlobalStyles';
import { Types } from '@scorenco/core';
import { PropsWithChildren } from 'react';

type WidgetsAppProps = PropsWithChildren<{
  widget?: Types.Widgets_Widget;
  noAds?: boolean;
}>;

export const WidgetsApp = ({ widget, noAds, children }: WidgetsAppProps) => {
  const theme = useTheme();

  const showScorencoFooter = widget?.settings?.display_scorenco_logo;

  return (
    <WidgetsGlobalStyles widget={widget}>
      <Paper
        variant="bordered"
        sx={{ alignItems: 'flex-start', p: 0, overflow: 'hidden' }}
      >
        {widget?.title && (
          <Box
            sx={{
              backgroundColor: theme.vars.palette.primary.main,
              width: '100%',
              textAlign: 'center',
              color: theme.vars.palette.primary.contrastText,
              padding: '0.5rem 0',
              fontWeight: 700,
            }}
          >
            {widget.title}
          </Box>
        )}

        {children}

        {widget && !noAds && <WidgetPopupAd widget={widget} />}

        {showScorencoFooter && <FooterScorenco />}
      </Paper>
    </WidgetsGlobalStyles>
  );
};
